import React, { useState, useRef, useEffect } from "react";
import "../../../incidents/cases/addCaseList.scss";
import FilterListIcon from "@mui/icons-material/FilterList";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import Buttons from "../../../../library/custom/button/Button";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import { TableLoader } from "../../../../library/common/Loader";
import {
  EXPIRATION_TYPE,
  LOGIN_ORG_ID,
  ORG_ID,
  GRID_DEFAULT_PAGE_SIZE,
  RESOURCETYPES,
  ROW_PER_PAGE_SIZE,
  SW3RD_PARTY_INSPECTOR,
  SW_CLIENT_MANAGER,
  USERID,
  USER_ID,
} from "../../../../constant/constant";
import NORow from "../../../../library/custom/noRow/noRow";
import DialogBox from "../../../../library/common/DialogBox";
import FilterCommonStatusSelect from "../../shared/FilterCommonStatusSelect";
import {
  getFormatedDate,
  InactiveClient,
  isDateExpired,
} from "../../../../utils/helper";
import {
  checkPrivileges,
  hasAllPrivileges,
} from "../../../../utils/rolesHelper";
import { Grid } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import SearchAutoComplete from "../../../../library/custom/searchAutoComplete/SearchAutoComplete";
import { PRODUCT_ID } from "../../../../constant/storm-water/constant";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import { useDebounce } from "../../../../utils/useDebounceSearch";

export default function ResourceList({
  isLoading,
  resources,
  addResource,
  getResourceListData,
  isShow,
  filterShow,
  handleDeleteOnClick,
  handleEditOnClick,
  resourceType,
  resourceCategory,
  isProfile = false,
  projectId,
  searchClient,
  autoSearchDataLoading,
  searchAllClientsReducerData,
  allProjects,
  handleAllProjectSearch,
  isProjectLoading,
  customerId,
  projectName,
  setClientsValue,
  clientsValue,
  resourcesdata,
  isShowDowdownloadButton = true,
  setProjectValue,
  filterObjHandle,
  shouldRestoreState,
  customerName,
  viewProjectOnClick,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [clientSearchText, setClientSearchText] = useState("");
  const debouncedClientSearch = useDebounce(clientSearchText, 500);
  const [projectSearchText, setProjectSearchText] = useState("");
  const debouncedProjectSearch = useDebounce(projectSearchText, 500);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(GRID_DEFAULT_PAGE_SIZE);
  const [clients, setClients] = useState(customerId || "");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const autoCompGroup = useRef(null);
  const [statusIds, setStatusIds] = useState();
  const [category, setCategory] = useState("");
  const [expirationType, setExpirationType] = useState("");
  const [isTableLoading, setisTableLoading] = useState(false);
  const [projects, setProjects] = useState({
    key: projectId ?? "",
    value: projectName ?? "",
  });
  const autoComp = useRef(null);
  const onchangeToDatePicker = (e) => {
    setToDate(e);
  };
  const onchangeFromDatePicker = (e) => {
    setFromDate(e);
  };
  const onSelectSearchCustomer = (e, value, reason) => {
    const nextClientKey = value?.key || "";
    const nextClientValue = value?.value || "";
    const resetProject = { key: "", value: "" };
    setProjects(resetProject);
    setProjectValue(resetProject);

    const data = {
      page: 1,
      pageSize: pageSize,
      search: "",
      resourceTypes: statusIds ? statusIds : "",
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      endDate: toDate ? getFormatedDate(toDate) : "",
      catId: category ? category : 0,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      orgId: nextClientKey || ORG_ID(),
      assetId: 0,
      assetTypeId: parseInt(PRODUCT_ID()) === 2 ? 5 : 0,
      isSendMail: false,
    };

    if (reason === "clear") {
      const nextFilterObj = { ...(resourcesdata?.filterObj || {}) };
      delete nextFilterObj.clientsValueKey;
      delete nextFilterObj.projectKeyValue;
      filterObjHandle(nextFilterObj);
      setClients("");
      setClientsValue({ key: "", value: "" });
      getResourceListData(data, true, null);
      return false;
    }
    setClients(nextClientKey || 0);
    setClientsValue({ key: nextClientKey, value: nextClientValue });
    const keyData = { key: nextClientKey, value: nextClientValue };

    getResourceListData(data, true, keyData);
  };
  useEffect(() => {
    if (shouldRestoreState && resourcesdata?.filterObj) {
      const f = resourcesdata.filterObj;
      setExpirationType(
        f.expirationType === 0 ? "all" : f.expirationType || "",
      );
      setClientsValue({
        value: f.clientsValueKey?.value ?? "",
        key: f.clientsValueKey?.key ?? "",
      });
      setClients(f.orgId || "");
      setProjects({
        value: f.projectKeyValue?.value ?? "",
        key: f.projectKeyValue?.key ?? "",
      });
      setCategory(f.catId || "");
      setSearch(f.search || "");
      setFromDate(f.startDate || "");
      setToDate(f.endDate || "");
      setPage((f.page || 1) - 1);
      setPageSize(f.pageSize || GRID_DEFAULT_PAGE_SIZE);
      // Restore resource type filter using the correct field (resourceTypes, not productId).
      const savedStatus = f.resourceTypes;
      if (
        savedStatus !== undefined &&
        savedStatus !== null &&
        savedStatus !== ""
      ) {
        const statusItem = RESOURCETYPES.find(
          (item) => item.key === savedStatus,
        );
        if (statusItem) {
          setFilter({ searchType: [statusItem] });
          setStatusIds(savedStatus);
        } else {
          setFilter({ searchType: [] });
          setStatusIds(undefined);
        }
      } else {
        setFilter({ searchType: [] });
        setStatusIds(undefined);
      }
    } else if (shouldRestoreState === false) {
      setStatusIds(undefined);
      setExpirationType("");
      setClientsValue({
        value: customerName ? customerName : "",
        key: customerId ? customerId : "",
      });
      setClients(customerId || "");
      setProjects({
        value: projectName ? projectName : "",
        key: projectId ? projectId : "",
      });
      setCategory("");
      setSearch("");
      setFromDate("");
      setToDate("");
      setPage(0);
      setPageSize(GRID_DEFAULT_PAGE_SIZE);
      setFilter({ searchType: [] });
    }
  }, [shouldRestoreState]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deleteResource = (resourceId) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(resourceId);
  };
  const deletehandle = () => {
    if (InactiveClient()) return;
    setOpenModal(false);
    handleDeleteOnClick(selectedRow);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.7 },
    { field: "category", headerName: "Category", flex: 1.8 },
    { field: "resourceTitle", headerName: "Resource Name", flex: 1.7 },
    { field: "assetType", headerName: "Asset Type", flex: 1.4 },
    { field: "projectName", headerName: "Asset Name", flex: 1.6 },
    { field: "dateOfEntry", headerName: "Date of Entry", flex: 1.6 },
    { field: "resourceType", headerName: "Resource Type", flex: 1.5 },
    { field: "addedBy", headerName: "Added by", flex: 1.5 },
    {
      field: "expirationDate",
      headerName: "Expiration Date",
      flex: 1.4,
      renderCell: (rows) => {
        return rows?.row?.expirationDate === null ? (
          "None"
        ) : (
          <div
            className={
              isDateExpired(rows?.row?.expirationDate) ? "expDate" : ""
            }
          >
            {rows?.row?.expirationDate}
          </div>
        );
      },
    },

    {
      field: "",
      flex: 1,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return filterShow ? (
          <ReportRowManipulte
            rows={rows}
            openLink
            edit={
              checkPrivileges([12]) ||
              (checkPrivileges([73, 74, 12]) &&
                parseInt(USER_ID()) === parseInt(rows?.row?.addedById))
            }
            deleted={
              checkPrivileges([12]) ||
              (checkPrivileges([12, 73, 74]) &&
                parseInt(USER_ID()) === parseInt(rows?.row?.addedById))
            }
            openLinkUrl={
              rows?.row?.resourceTypeId === 2
                ? `${rows?.row?.linkUrls[0]}`
                : `${rows?.row?.fileUrls[0]}`
            }
            openLinkLabel={
              rows?.row?.resourceTypeId === 2
                ? "Open Link"
                : "Download Resource"
            }
            deleteOnClick={(row) => deleteResource(row?.id)}
            editOnClick={(row) => handleEditOnClick(row)}
            deleteLabel="Delete Resource"
            editLabel="Edit Resource"
            viewProject={rows?.row?.projectId}
            viewProjectOnClick={(row) => viewProjectOnClick(row)}
            viewProjectLabel="View Project"
          />
        ) : (
          ""
        );
      },
    },
  ];

  const handleSearch = (data) => {
    setAnchorEl(null);
    getResourceListData(data, true);
  };

  const handleautoSearch = (event) => {
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    const data = {
      page: newPage + 1,
      pageSize: pageSize,
      search: search,
      resourceTypes: statusIds ? statusIds : "",
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      endDate: toDate ? getFormatedDate(toDate) : "",
      catId: category ? category : 0,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      orgId: clients ? clients : isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      assetId: projects?.key || 0,
      assetTypeId: parseInt(PRODUCT_ID()) === 2 ? 5 : 0,
      expirationType: expirationType === "all" ? 0 : expirationType,
      isSendMail: false,
    };
    getResourceListData(data, true);
  };

  const handleApply = () => {
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    const data = {
      statusIds: "",
      page: 1,
      pageSize: pageSize,
      resourceTypes: statusIds ? statusIds : "",
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      endDate: toDate ? getFormatedDate(toDate) : "",
      catId: category ? category : "",
      search: search,
      orgId: clients ? clients : isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      userId: isProfile ? USERID : 0,
      assetId: projects?.key || 0,
      assetTypeId: parseInt(PRODUCT_ID()) === 2 ? 5 : 0,
      expirationType: expirationType === "all" ? 0 : expirationType,
      isSendMail: false,
    };
    handleSearch(data);
  };

  const handleClear = () => {
    setPage(0);
    setPageSize(GRID_DEFAULT_PAGE_SIZE);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setCategory("");
    setStatusIds("");
    setFromDate("");
    setToDate("");
    setExpirationType("");
    setSearch("");
    setFilter((prevState) => {
      const prevStates = { ...prevState };
      prevStates.searchType = [];
      return prevStates;
    });
    const data = {
      statusIds: "",
      page: 1,
      pageSize: GRID_DEFAULT_PAGE_SIZE,
      resourceTypes: "",
      startDate: "",
      endDate: "",
      catId: "",
      search: "",
      orgId: clients ? clients : isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      userId: isProfile ? USERID : 0,
      assetId: projects?.key || 0,
      assetTypeId: parseInt(PRODUCT_ID()) === 2 ? 5 : 0,
      expirationType: "",
      isSendMail: false,
    };
    handleSearch(data);
  };

  const [filter, setFilter] = useState({
    searchType: [],
  });

  const categoryOnChanges = (e) => {
    setCategory(e.target.value);
  };

  const expirationTypeOnChanges = (e) => {
    setExpirationType(e.target.value);
  };

  const onChangeType = (item) => {
    setFilter((prevState) => {
      const prevStates = { ...prevState };
      const searchType = prevStates.searchType;
      const filter =
        searchType && searchType.filter((its) => its?.key === item?.key);
      if (filter[0] === undefined) {
        prevStates.searchType = [item];
        setStatusIds(item?.key);
      } else {
        prevStates.searchType = [];
      }
      return prevStates;
    });
  };
  // clientsValueKey
  const typeOnchange = (event) => {
    const inputValue = String(event.target?.value || "").trim();
    if (inputValue) {
      setClientSearchText(inputValue);
    }
  };

  const projectTypeOnchange = (event) => {
    const inputValue = String(event.target?.value || "").trim();
    setProjectSearchText(inputValue);
  };

  const onChangeProjects = (e, value, reason) => {
    const next = { key: value?.key ?? "", value: value?.value ?? "" };
    setProjects(next);
    setProjectValue(next);

    const data = {
      page: 1,
      pageSize: pageSize,
      search: "",
      resourceTypes: statusIds ? statusIds : "",
      catId: category ? category : 0,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      orgId: clients ? clients : isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      assetId: value?.key ?? 0,
      assetTypeId: parseInt(PRODUCT_ID()) === 2 ? 5 : 0,
      isSendMail: false,
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      endDate: toDate ? getFormatedDate(toDate) : "",
    };

    if (reason === "clear") {
      const cleared = { key: "", value: "" };
      setProjects(cleared);
      setProjectValue(cleared);
      data.assetId = 0;
      getResourceListData(data, true, null, true);
      return false;
    }
    const projectKeyValue = {
      key: value?.key ?? "",
      value: value?.value ?? "",
    };

    getResourceListData(data, true, projectKeyValue, true);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    const data = {
      page: 1,
      pageSize: newPazeSize,
      search: search,
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      endDate: toDate ? getFormatedDate(toDate) : "",
      resourceTypes: statusIds ? statusIds : "",
      catId: category ? category : 0,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      orgId: clients ? clients : isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      assetId: projects?.key || 0,
      assetTypeId: parseInt(PRODUCT_ID()) === 2 ? 5 : 0,
      isSendMail: false,
      expirationType: expirationType === "all" ? 0 : expirationType,
    };
    getResourceListData(data, true);
  };

  const sendEmail = () => {
    if (InactiveClient()) return;
    const data = {
      statusIds: "",
      page: 1,
      pageSize: pageSize,
      resourceTypes: statusIds ? statusIds : "",
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      endDate: toDate ? getFormatedDate(toDate) : "",
      catId: category ? category : "",
      search: search,
      orgId: clients ? clients : isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      userId: isProfile ? USERID : 0,
      assetId: projects?.key ? projects?.key : 0,
      assetTypeId: parseInt(PRODUCT_ID()) === 2 ? 5 : 0,
      expirationType: expirationType === "all" ? 0 : expirationType,
      isSendMail: true,
    };
    getResourceListData(data, true);
  };
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPage(0);
    const data = {
      page: 1,
      pageSize: pageSize,
      search: debouncedSearch ? debouncedSearch : "",
      resourceTypes: statusIds ? statusIds : "",
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      endDate: toDate ? getFormatedDate(toDate) : "",
      catId: category ? category : 0,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      orgId: clients ? clients : isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      assetId: projects?.key ? projects?.key : 0,
      assetTypeId: parseInt(PRODUCT_ID()) === 2 ? 5 : 0,
      expirationType: expirationType === "all" ? 0 : expirationType,
      isSendMail: false,
    };
    getResourceListData(data, true);
  }, [debouncedSearch]);

  const isClientFirstRender = useRef(true);

  useEffect(() => {
    if (isClientFirstRender.current) {
      isClientFirstRender.current = false;
      return;
    }
    if (!debouncedClientSearch?.trim()) return;
    searchClient(debouncedClientSearch);
  }, [debouncedClientSearch]);

  const isProjectFirstRender = useRef(true);

  useEffect(() => {
    if (isProjectFirstRender.current) {
      isProjectFirstRender.current = false;
      return;
    }
    if (!debouncedProjectSearch?.trim()) return;
    handleAllProjectSearch(
      { target: { value: debouncedProjectSearch } },
      debouncedProjectSearch,
      clients,
    );
  }, [debouncedProjectSearch]);

  const CHECK_PRE_SHOW =
    hasAllPrivileges(SW_CLIENT_MANAGER) ||
    hasAllPrivileges(SW3RD_PARTY_INSPECTOR);
  return (
    <>
      <section className="grid_main_sec">
        {openModal && (
          <DialogBox
            open={openModal}
            rows={[]}
            header={"Confirm Deletion"}
            deletehandle={deletehandle}
            handleCloseModal={() => setOpenModal(false)}
            content={"Are you sure you want to delete this Resource?"}
            view
          />
        )}

        {isShow && checkPrivileges([12, 73, 74]) && (
          <div className="grid_main_header two_grid">
            <div className="grid_heading_style">Resource Library</div>
            <div>
              <Buttons
                id="btnAddResource"
                varientAddIconBlue={true}
                label={"Add Resource"}
                onClick={() => addResource()}
              />
            </div>
          </div>
        )}

        <Grid container gap={1}>
          {checkPrivileges([12, 17]) && PRODUCT_ID() == 2 && ORG_ID() == 1 && (
            <Grid item lg={4.5} xs={12} sm={12} md={6} mb={3}>
              <FormControl fullWidth>
                <FormLabels label="Client" isRequired={false} />
                <SearchAutoComplete
                  name="Customer"
                  optionsData={
                    autoSearchDataLoading
                      ? []
                      : (searchAllClientsReducerData?.data ?? [])
                  }
                  typeOnchange={(event, value) => typeOnchange(event)}
                  isKeyValuePair={true}
                  value={clientsValue ? clientsValue : ""}
                  onChange={(event, value, reason) =>
                    onSelectSearchCustomer(event, value, reason)
                  }
                  isLoading={autoSearchDataLoading}
                  noOptionsTextMsg="No Client"
                  autoCompClear={autoCompGroup}
                />
              </FormControl>
            </Grid>
          )}

          {/* {(checkPrivileges([12, 17]) || CHECK_PRE_SHOW) &&
            PRODUCT_ID() == 2 &&
            ORG_ID() == 1 && ( */}

          {PRODUCT_ID() == 2 && (
            <Grid lg={4.5} xs={12} sm={12} md={6} item mb={3}>
              <FormControl fullWidth>
                <FormLabels label="Project" isRequired={false} />
                <SearchAutoComplete
                  name="Add Individual Users"
                  optionsData={allProjects ?? []}
                  // typeOnchange={(event, value) =>
                  //   handleAllProjectSearch(event, value, clients)
                  // }
                  typeOnchange={(event) => projectTypeOnchange(event)}
                  isKeyValuePair={true}
                  value={projects}
                  onChange={(e, value, reason) =>
                    onChangeProjects(e, value, reason)
                  }
                  isLoading={isProjectLoading}
                  autoCompClear={autoComp}
                  noOptionsTextMsg={"No Project"}
                />
              </FormControl>
            </Grid>
          )}
        </Grid>

        <div className="grid_main_body">
          <div className="div-filter-container">
            <div className="filter_of_caselist">
              <div className="searchcaseid">
                <label htmlFor="search">
                  <span>
                    <SearchIcon />
                  </span>
                  <div>
                    <input
                      id="search"
                      placeholder="Search"
                      type="text"
                      value={search}
                      className=""
                      onChange={handleautoSearch}
                      autoComplete="off"
                    />
                  </div>
                </label>
              </div>
              <div className="filter_btn">
                <button
                  aria-describedby={id}
                  variant="contained"
                  type="button"
                  name="btn"
                  onClick={(e) => handleClick(e)}
                >
                  <FilterListIcon id="icn" /> Filters
                </button>

                <FilterCommonStatusSelect
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  handleClose={handleClose}
                  statusType={resourceType}
                  categoryType={resourceCategory}
                  category={category}
                  handleApply={handleApply}
                  handleClear={handleClear}
                  filter={filter}
                  categoryOnChanges={categoryOnChanges}
                  expirationTypeList={EXPIRATION_TYPE}
                  expirationType={expirationType}
                  expirationTypeOnChanges={expirationTypeOnChanges}
                  onChangeType={onChangeType}
                  statusIds={statusIds}
                  filterSelect={true}
                  filterStatus={true}
                  resetBtn={true}
                  label="Resource Type"
                  filterDate={true}
                  toDate={toDate}
                  fromDate={fromDate}
                  onchangeToDatePicker={onchangeToDatePicker}
                  onchangeFromDatePicker={onchangeFromDatePicker}
                />
              </div>
            </div>
            {isShowDowdownloadButton && (
              <div className="div-download-email-right" onClick={sendEmail}>
                <span>
                  <img
                    src={downloadIcon}
                    className="DownLoadLogo"
                    alt="DownLoad Logo"
                  />
                </span>
                Download Data
              </div>
            )}
          </div>

          <div className="desc_box row_uniq">
            <div className="table_style_ui">
              {isTableLoading ? (
                ""
              ) : (
                <GridTable
                  getRowId={(r) => r.id}
                  rows={
                    resources?.resourceData
                      ? resources.resourceData.map((x, index) => {
                          x.dateOfEntry = getFormatedDate(x.dateOfEntry);
                          return x;
                        })
                      : []
                  }
                  rowCount={resources?.noOfRecords ?? 0}
                  columns={columns}
                  checkboxSelection={false}
                  loading={isLoading}
                  page={page}
                  pagination
                  pageSize={pageSize}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePagignation}
                  backIconButtonProps={{ disabled: false }}
                  disableSelectionOnClick
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
